import _extends from "@babel/runtime/helpers/esm/extends";
export function getOrCreateMessage(store, messageId, conversationId, author) {
  const existingMessage = store.state.messagesById[messageId];
  if (existingMessage) {
    const nextMessage = existingMessage.status === 'streaming' ? existingMessage : _extends({}, existingMessage, {
      conversationId: existingMessage.conversationId ?? conversationId,
      status: 'streaming'
    });
    if (nextMessage !== existingMessage) {
      store.updateMessage(messageId, nextMessage);
    }
    return store.state.messagesById[messageId] ?? nextMessage;
  }
  const resolvedAuthor = author ?? store.assistantUser;
  const nextMessage = _extends({
    id: messageId,
    conversationId,
    role: 'assistant',
    parts: [],
    status: 'streaming'
  }, resolvedAuthor ? {
    author: resolvedAuthor
  } : undefined);
  store.addMessage(nextMessage);
  return store.state.messagesById[messageId] ?? nextMessage;
}
export function getFinishMessage(store, messageId, conversationId, status) {
  if (messageId) {
    const existingMessage = store.state.messagesById[messageId];
    if (existingMessage) {
      return existingMessage;
    }
  }
  return {
    id: messageId ?? '',
    conversationId,
    role: 'assistant',
    parts: [],
    status
  };
}
export function finalizeStreamingParts(parts) {
  let didChange = false;
  const nextParts = parts.map(part => {
    if ((part.type === 'text' || part.type === 'reasoning') && part.state === 'streaming') {
      didChange = true;
      return _extends({}, part, {
        state: 'done'
      });
    }
    return part;
  });
  return didChange ? nextParts : parts;
}
export function updateMessageParts(store, messageId, updater) {
  const message = store.state.messagesById[messageId];
  if (!message) {
    return;
  }
  const nextParts = updater(message.parts);
  if (nextParts !== message.parts) {
    store.updateMessage(messageId, {
      parts: nextParts
    });
  }
}
export function updateMessage(store, messageId, updater) {
  const message = store.state.messagesById[messageId];
  if (!message) {
    return;
  }
  const patch = updater(message);
  if (patch) {
    store.updateMessage(messageId, patch);
  }
}
export function findLastStreamingPartIndex(parts, type) {
  for (let index = parts.length - 1; index >= 0; index -= 1) {
    const part = parts[index];
    if (part.type === type && part.state === 'streaming') {
      return index;
    }
  }
  return -1;
}